document.addEventListener("DOMContentLoaded", function () {

  const openBtns = document.querySelectorAll(".open-video-popup");
  const popup = document.querySelector(".video-popup");
  const closeBtn = document.querySelector(".close-video");
  const video = document.getElementById("globalVideo");
  const source = document.getElementById("videoSource");

  // Only add event listeners if popup exists
  if (popup) {

    openBtns.forEach(btn => {
      btn.addEventListener("click", function () {

        const videoUrl = this.getAttribute("data-video-url");

        if (videoUrl && source) {
          source.src = videoUrl;

          video.load();

          video.onloadeddata = () => {
            video.play();
          };
        }

        popup.classList.add("active");
        document.body.classList.add("overflow-hidden");
      });
    });

    function closePopup() {
      popup.classList.remove("active");
      document.body.classList.remove("overflow-hidden");

      if (video) {
        video.pause();
        video.currentTime = 0;
        source.src = "";
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    popup.addEventListener("click", function (e) {
      if (e.target.classList.contains("video-popup-overlay")) {
        closePopup();
      }
    });
  }

  // IntersectionObserver part
  const elements = document.querySelectorAll('.animate-left, .animate-right, .animate-up');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-show');
      }
    });
  }, {
    threshold: 0.2
  });

  elements.forEach(el => observer.observe(el));

});